import React from "react";

function UpArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="12.222"
      viewBox="0 0 20 12.222"
    >
      <path
        id="Path_19901"
        data-name="Path 19901"
        d="M15.636,12.666l7.778,7.778,2.222-2.222-10-10-10,10,2.222,2.222Z"
        transform="translate(-5.636 -8.222)"
        fill="#596970"
      />
    </svg>
  );
}

export default UpArrow;
